import { CustomTheme } from '@nemuru-eng/js-api-client';
import { useFormContext } from 'react-hook-form';

import { useSetIsDirtyListener } from '@/components/modules/Application/hooks/useSetDirtyListener';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { DateFormField } from '@/components/shared/components/NewContextForms/DateFormField';
import { PhoneFormDoubleField } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/PhoneFormDoubleField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

interface CustomerContactDataFormProps extends FormGridOptions {
  availableCountriesIso2?: string[];
  showBirthDate: boolean;
}

export const CustomerContactDataForm = ({
  fieldVariant,
  fullWidth = false,
  availableCountriesIso2,
  showBirthDate,
}: CustomerContactDataFormProps) => {
  const {
    actions: { updateApplicationContext },
    state: { customerData, selectedAgent },
  } = useApplicationContext();

  const { watch, formState } = useFormContext();
  useSetIsDirtyListener(formState.isDirty);

  const firstNameWatcher = watch('firstName') as string;
  const lastNameWatcher = watch('lastName') as string;
  const isDocumentNumberRequired = selectedAgent?.customTheme === CustomTheme.KTUIN;

  return (
    <FormGridContainer fieldVariant={fieldVariant} direction={'row'} fullWidth={fullWidth}>
      <TextFormField
        autoFocus
        name={'firstName'}
        onBlurCapture={() =>
          updateApplicationContext({ customerData: { ...customerData!, firstName: firstNameWatcher } })
        }
        label={'FIRST_NAME'}
        fieldVariant={fieldVariant}
      />
      <TextFormField
        name={'lastName'}
        label={'LAST_NAME'}
        onBlurCapture={() =>
          updateApplicationContext({ customerData: { ...customerData!, lastName: lastNameWatcher } })
        }
        fieldVariant={fieldVariant}
      />
      <TextFormField name={'email'} label={'EMAIL'} fieldVariant={fieldVariant} />
      <PhoneFormDoubleField fieldVariant={fieldVariant} availableCountriesIso2={availableCountriesIso2} />
      <TextFormField
        name={'documentNumber'}
        label={'DOCUMENT_ID_NUMBER'}
        fieldVariant={fieldVariant}
        markAsOptional={!isDocumentNumberRequired}
      />
      {showBirthDate && <DateFormField name="birthDate" label="BIRTH_DATE" fieldVariant={fieldVariant} disableFuture />}
    </FormGridContainer>
  );
};
